import axios from "axios";
import React, { useState, useEffect } from "react";
import { Loader2 } from "./webWorkers/LoaderFile/Loader";
import { API_Link, validateHeader } from "../commons/Constants";

const AdminLookupsListingComponent = () => {
  const MD5hash = validateHeader();
  // set useState
  const [isLoading, setIsLoading] = useState(false);
  const [lookupsListing, setlookupsListing] = useState([]);

  // get Token
  const user = JSON.parse(localStorage.getItem("user"));
  const token = user?.token;

  const getLookupsList = async () => {
    // api Call
    setIsLoading(true);
    await axios
      .get(`${API_Link}getLookups?options=true`, {
        headers: {
          "misr-auth": MD5hash,
          Authorization: `Bearer ${token}`,
        },
      })
      .then((res) => {
        setlookupsListing(res.data.lookups);
        setIsLoading(false);
      });
    // .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    getLookupsList();
  }, []);

  return (
    <div className="page--content ">
      <div className="row sticky-title align-items-center">
        <div className="col-md-6 col-lg-6">
          <h1 className="page--heading ">Lookups Listing</h1>
        </div>
      </div>
      <div className="row ">
        <div className="padding-table">
          <div className="table--template">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th>Sr.No</th>
                  <th>Title</th>
                  <th>Options</th>
                  <td>Action</td>
                </tr>
              </thead>
              <tbody>
                {!isLoading &&
                  lookupsListing &&
                  lookupsListing?.map((lookups, index) => (
                    <tr>
                      <td>{index + 1} </td>
                      <td>{lookups.title}</td>
                      <td>
                        <select className="form-select">
                          {lookups.options?.map((option) => {
                            return <option>{option?.label}</option>;
                          })}
                        </select>{" "}
                      </td>
                      <td>
                        <button className="btn btn-primary">Edit</button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {isLoading && (
              <div className="role-listing-loader d-flex">
                <Loader2 />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLookupsListingComponent;
